import React from 'react';

import * as Styled from './divider.style';

export type DividerProps = {
  className?: string;
  noMargin?: boolean;
};

export const Divider: React.FC<DividerProps> = ({ className, noMargin }) => (
  <Styled.Divider className={className} $noMargin={noMargin} />
);
